import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

export const PricingCTABanner = () => {
  return (
    <section className="relative py-24 px-4 sm:px-6 lg:px-8 overflow-hidden">
      {/* Background Image */}
      <img 
        src="https://images.unsplash.com/photo-1464207687429-7505649dae38?w=1920&q=80"
        alt="Evening camp meal setup with glowing lanterns"
        className="absolute inset-0 w-full h-full object-cover"
      />
      
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-deep-teal/90 via-midnight-green/85 to-deep-teal/90" />
      
      {/* Animated background effect */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-10 left-10 w-32 h-32 bg-copper rounded-full blur-3xl animate-pulse-slow"></div>
        <div className="absolute bottom-20 right-20 w-40 h-40 bg-copper/60 rounded-full blur-3xl animate-pulse-slow" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-1/2 left-1/3 w-24 h-24 bg-ivory/30 rounded-full blur-2xl animate-pulse-slow" style={{ animationDelay: '0.5s' }}></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10">
        <h2 className="text-4xl md:text-5xl font-bold text-ivory mb-6">
          From First Meal to Final Order — CampChef Pro Has You Covered
        </h2>
        <p className="text-xl text-ivory/90 mb-10 max-w-2xl mx-auto leading-relaxed">
          Save time, reduce waste, and bring peace of mind to your camp kitchen — session after session.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button 
            asChild 
            size="lg"
            className="min-w-[200px] bg-copper hover:bg-copper/90 text-deep-teal font-semibold shadow-xl hover:shadow-2xl hover:scale-105 transition-all"
          >
            <Link to="/contact">Request a Demo</Link>
          </Button>
          <Button 
            asChild 
            size="lg" 
            variant="outline"
            className="min-w-[200px] border-2 border-ivory text-ivory bg-ivory/20 hover:bg-ivory/30 hover:border-ivory transition-all"
          >
            <Link to="/contact">Contact Sales</Link>
          </Button>
        </div>
        <p className="text-sm text-ivory/70 mt-8">
          Talk to our team to get started • Personalized onboarding • Custom pricing available
        </p>
      </div>
    </section>
  );
};
